import {
  NumberInput,
  coerceCssPixelValue,
  coerceNumberProperty,
} from '@angular/cdk/coercion';
import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[luiSize]',
  standalone: true,
})
export class SizeDirective {
  @Input() get width() {
    return this._width;
  }
  set width(value: NumberInput) {
    this._width = coerceNumberProperty(value);
  }
  private _width!: number;

  @Input() get height() {
    return this._height;
  }
  set height(value: NumberInput) {
    this._height = coerceNumberProperty(value);
  }
  private _height!: number;

  @HostBinding('style.width') get widthStyle() {
    return this.width ? coerceCssPixelValue(this.width) : 'auto';
  }

  @HostBinding('style.height') get heightStyle() {
    return this.height ? coerceCssPixelValue(this.height) : 'auto';
  }
}
